// extracted by mini-css-extract-plugin
export default {"maincontainer":"Home_maincontainer__kxrcC","selectedtype":"Home_selectedtype__6+DVT","leftcontainer":"Home_leftcontainer__s8xoJ","rightcontainer":"Home_rightcontainer__Fej+r"};